/**
 * What is left of the spectrum at this depth.
 *
 * This is the honest counterpart to the colour tokens: what the camera cannot
 * see, it cannot white balance back. When the bars go dark the app should stop
 * promising colour and start recommending lights.
 */

import { spectrumAt } from "../lib/engine";
import type { WaterType } from "../lib/conditions";

export function Spectrum({ depthM, water }: { depthM: number; water: WaterType }) {
  const bands = spectrumAt(depthM, water);
  const lost = bands.filter((b) => b.left < 0.08).map((b) => b.key);

  return (
    <div>
      <div className="mt-2.5 grid gap-[3px]">
        {bands.map((band) => (
          <div key={band.key} className="grid grid-cols-[14px_1fr] items-center gap-1.5">
            <i className="font-mono text-[10px] not-italic text-graphite-2">{band.key}</i>
            <span
              className="block h-[7px] rounded-[1px] transition-[width,opacity] duration-200"
              style={{
                background: band.hex,
                opacity: 0.12 + band.left * 0.88,
                width: `${16 + band.left * 84}%`,
              }}
            />
          </div>
        ))}
      </div>
      <p className="mt-1.5 text-[11px] leading-tight text-graphite-2">
        {lost.length
          ? `Gone at this depth: ${lost.join(", ")}. What the camera cannot see, it cannot white balance back.`
          : "Full spectrum still reaching you."}
      </p>
    </div>
  );
}
